/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext } from 'react';
import { Container, Row, Col, Button, } from 'reactstrap';
import Footer from '../footer';
import getEncodedImageUrl from '../../helpers/get-encoded-image';
import { EslidesEvent, Presentation } from '../../types/presentation';
import SocketClient from '../../helpers/connection';
import { log } from 'console';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory } from "react-router-dom";
import EventContext from "../../contexts/event";
import { socketURL } from '../../helpers/constants';
import {useQuery, useSubscription} from "@apollo/client";
import {question_query, quiz_actions} from "../../gql/quiz-gql";
import axios from "axios";
import {Question} from "../../types/quiz";

// quiz live home screen for listing user in speaker mode
const QuizIntro: React.FC<{ locale: string; setLocale: any; ppt: Presentation; event: EslidesEvent; screenMode?: boolean }> = ({ locale, setLocale, ppt, event, screenMode = false }) => {

  const [slider, setSlider] = useState(0);
  const connectedUsers = 18;
  const intl = useIntl();
  const history = useHistory();
  const eventContext = useContext(EventContext);


    // sync action with backend data call
    const {data: actionData,error: actionError} = useSubscription(quiz_actions, {
        variables: {
            presentation_id: ppt && ppt._id
        },
        skip: !ppt
    },);


    const {data: secondQueryData, loading: secondLoading, error: secondError} = useQuery<{
        questions: Array<Question>;

    }>(question_query, {
        variables: {
            presentation_id: ppt._id,
        },
        skip: !ppt,

    });

    //initial set timer call function
    useEffect(()=>{
        startCheckTimer()
    },[])

    // handle action data based on socket message
    useEffect(() => {
        if(actionData){
            let type= actionData.quiz_actions[0].action;
            if (type === 'start_quiz') {
                history.push(
                    `/${eventContext.slug}/${ppt._id}/questions`,{'secondQueryData':secondQueryData}
                )
            }
            console.log("EVENT_CHANGE",actionData.quiz_actions[0].action)
        }
    }, [actionData]);


    // check action in database for data change
    function startCheckTimer() {
        console.log("check_quiz_action","Timer called");
        setInterval(async () => {
            await axios
                .post(
                    `${process.env.REACT_APP_API_ENDPOINT}/api/quiz/get-user-action`,
                    {
                        _id: ppt._id,
                    },

                ).then((res) => {
                    console.log("check_quiz_action",res);

                    if(res.data.data.action!=null && res.data.data.action!==""){
                        history.push(
                            `/${eventContext.slug}/${ppt._id}/questions`
                        )
                    }
                });

        },10000)
    }



  return (
    <>
      <div className="quiz-home-page-container d-flex align-items-center justify-content-center" style={{ height: '90%'}} >
              <div className="quiz-home-header m-t-10">
                <Container fluid>
                  <Row className='p-2' >

                    <Col className="text-center ">
                      <img className="m-t-5" height={120} src="/images/tutorial-1.svg" alt="quiz" />
                      <h4 className="quiz-home-title">PLAY</h4></Col>

                  </Row>
                </Container>
              </div>
              <div className="quiz-home-body ">
                {/* div className='container' */}
                <Container>
                  <Row>
                    <Col lg={10} xl={8} md={12} className="mx-auto text-center" >
                      <p className="quiz-body-text">
                        <br/> <span>{intl.formatMessage({id: 'quiz.intro.msg'})}</span>

                      </p>
                    </Col>
                  </Row>
                </Container>
              </div>

            </div>
            <Footer />

    </>

  )
}

export default QuizIntro;
